import * as React from 'react';

var _circle, _path, _path2, _path3, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgSol = function SvgSol(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#000"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_1593_3853)",
        d: "M37.195 74.215a2.25 2.25 0 0 1 1.594-.659h54.987c1.005 0 1.508 1.213.797 1.923L83.711 86.342a2.25 2.25 0 0 1-1.594.658H27.13c-1.005 0-1.508-1.213-.797-1.923z"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_1593_3853)",
        d: "M37.195 33.658A2.32 2.32 0 0 1 38.789 33h54.987c1.005 0 1.508 1.213.797 1.923L83.711 45.785a2.25 2.25 0 0 1-1.594.659H27.13c-1.005 0-1.508-1.213-.797-1.923z"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint2_linear_1593_3853)",
        d: "M83.71 53.807a2.25 2.25 0 0 0-1.593-.659H27.13c-1.005 0-1.508 1.213-.797 1.923l10.862 10.863c.416.415.987.658 1.594.658h54.987c1.005 0 1.508-1.213.797-1.923z"
    })), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_1593_3853",
        x1: -98.281,
        x2: -99.744,
        y1: 22.799,
        y2: 96.418,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00FFA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#DC1FFF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_1593_3853",
        x1: -114.921,
        x2: -116.384,
        y1: 14.111,
        y2: 87.731,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00FFA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#DC1FFF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_1593_3853",
        x1: -106.654,
        x2: -108.117,
        y1: 18.427,
        y2: 92.046,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00FFA3"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#DC1FFF"
    })))));
};

export { SvgSol as ReactComponent };
//# sourceMappingURL=SOL.svg.es.js.map
